export const data = {
    tooltip: {
        show: true,
        headerFormat: "",
        formatter: (params) =>
            params.name
                ? "<b>" + params.name + "</b>: " + params.value + " devices"
                : params.value + " devices",
        backgroundColor: "#333D44",
        borderRadius: 10,
        borderWidth: 0,
        padding: 15,
        followPointer: true,
        textStyle: {
            color: "#fff",
        },
    },
    credits: {
        enabled: false,
    },
    color: [
        "transparent",
        "#1092C9",
        "#9766C9",
        "#FFED8B",
        "#72B566",
        "#EC3323",
        "#30404D",
        "#3CC8D1",
        "#F3c85C",
        "#66B5B0",
        "#F4A83B",
        "#CED9E0",
        "#A185DC",
        "#D41B0B",
        "#72B566",
    ],
    series: {
        type: "sunburst",
        cursor: "pointer",
        radius: [0, "100%"],
        label: {
            rotate: "radial",
            align: "center",
            minAngle: 12,
            ellipsis: "...",
            overflow: "truncate",
            hideOverlap: true,
            width: 70,
        },
        emphasis: {
            focus: "ancestor",
        },
        data: [],
    },
};
